<template>
  <div>
    <page-title pageName="系统设置"/>
    <div class='comm-container'>
      <div class='comm-page-container' style="padding:30px;">
        <div class="file-con" v-for="item in fileList" >
            <el-upload
                :headers="{'authorization':token}"
                :action="baseUrl+'upload/uploadBannerFile'"
                :show-file-list="false"
                :on-remove="handleRemove"
                :on-progress='handleProgress'
                :on-success="handleAvatarSuccess"
                :before-upload="(file) => beforeAvatarUpload(file, item)"
                >
                <img
                    v-if="item.url"
                    :src="item.url"
                    width="200px" height="200px"
                    class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class='img-mask1' v-if='item.url'>
                <i class='oper-img-btn el-icon-delete' @click='handleRemove(item)'></i>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BannerManage',
  data () {
    return {
      token: localStorage.getItem('user_token'),
      baseUrl: this.$api.baseUrl,
      fileList:[],
      currHost:window.location.host,
      currBanner:{}
    }
  },
  mounted () {
    this.initBanner()
    this.getBanner()
  },
  methods: {
    initBanner(){
        this.fileList = []
        for(let i = 1;i<=5;i++){
            let obj = {
                bannerOrder: i
            }
            this.fileList.push(obj)
        }
        console.log(this.fileList)
    },
    getBanner(){
        this.$ajax({
            method:'post',
            url:'systemSet/selectBanner',
            data:{}
        }).then(res => {
            if(res.data.code > 0){
                let arr = res.data.list || []
                let temp = this.fileList
                arr.forEach((item,index) => {
                    item.url ='//'+this.currHost+'/img/'+item.bannerUrl
                    // item.url  = 'http://www.xhxh1993.com/img/'+item.bannerUrl
                    // item.url ='//192.168.2.100:8080/img/'+item.bannerUrl
                    temp[item.bannerOrder - 1] = item
                })
                this.fileList = JSON.parse(JSON.stringify(temp))
            }else{
                this.$message.warning(res.data.desc)
            }
        })
    },
    addBaner(url){
        let params = {
            bannerUrl:url,
            bannerOrder:this.currBanner.bannerOrder
        }
        console.log('----------------')
        console.log(params)
        // return 
        this.$ajax({
            method:'post',
            url:'systemSet/addBaner',
            data:params
        }).then(res => {
            if(res.data.code > 0){
                this.$message.success('添加成功！')
                this.initBanner()
                this.getBanner()
            }else{
                this.$message.warning(res.data.desc)
            }
        })
    },
    handleRemove(item) {
        this.$ajax({
            method:'post',
            url:'systemSet/deleteBanner',
            data:{bannerId:item.bannerId}
        }).then(res => {
            if(res.data.code > 0){
                this.$message.success('删除成功！')
                this.initBanner()
                this.getBanner()
            }else{
                this.$message.warning(res.data.desc)
            }
        })
    },
    beforeAvatarUpload(file,item){
        const isJPG = file.type === 'image/jpeg';
        const isPng = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPng) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
        }
        this.currBanner = item
        console.log('======')
        console.log(item)
        return (isJPG || isPng) && isLt2M;
    },
    handleAvatarSuccess(res){
        if(res.code > 0){
            this.addBaner(res.data)
        }else if(res.code === -2){
            this.$router.push({
            path: '/login'
            })
        }else{
            this.$message.warning(res.desc)
        }
    },
    handleProgress(){}
  }
}
</script>
<style scoped>
.setting-txt{
  padding-top:12px;
  font-size:14px;
}
.comm-page-container{
    display: flex;
}
.file-con{
    position: relative;
    width: 200px;
    height:200px;
    border:1px solid #f2f2f2;
    margin-right:20px;
    border-radius: 6px;
    overflow: hidden;
}
.file-con:hover .img-mask1{
    display: block;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
.img-mask1{
    display: none;
    position: absolute;
    width:200px;
    height:200px;
    top:0;
    left:0;
    bottom:0;
    right:0;
    background: rgba(0,0,0,.4);
    border-radius: 6px;
    text-align: center;
  }
  .img-mask1 .oper-img-btn{
    color:#fff;
    font-size:24px;
    padding:15px;
    cursor: pointer;
    margin:75px 0 0;
  }
</style>
